// extracted by mini-css-extract-plugin
export default {"col":"dhf2R3_1","item":"dR4AZUR9","borderItem":"jBZJrY3a","backgroundItem":"sxRruFh4"};